import React from 'react';

function Process() {
  return (
    <section className="process section-padding">
      <div className="container">
        <div className="sec-head mb-80">
          <h6 className="sub-title main-color mb-25">Our Process</h6>
          <div className="bord pt-25 bord-thin-top d-flex align-items-center">
            <h2 className="fw-600">
              Business <span className="fw-200">Development</span>
            </h2>
          
          </div>
        </div>
        <div className="row md-marg">
          <div className="col-lg-3 col-md-6 item md-mb50">
            <div className="icon-img-60 mb-30">
              <img src="/dark/assets/imgs/serv-icons/devproc1.png" alt="" />
            </div>
            <h5 className="mb-15">Research</h5>
            <p>
            Assess the customer&apos;s home and gather detailed information about their requirements to understand their specific needs and preferences.
            </p>
            
          </div>
          <div className="col-lg-3 col-md-6 item md-mb50">
            <div className="icon-img-60 mb-30">
              <img src="/dark/assets/imgs/serv-icons/devproc2.png" alt="" />
            </div>
            <h5 className="mb-15">Concept</h5>
            <p>
            Design a tailored service plan with creative solutions, ensuring it meets the customer&apos;s requirements and enhances their living space.
            </p>
            
          </div>
          <div className="col-lg-3 col-md-6 item sm-mb50">
            <div className="icon-img-60 mb-30">
              <img src="/dark/assets/imgs/serv-icons/devproc3.png" alt="" />
            </div>
            <h5 className="mb-15">Implement</h5>
            <p>
            Execute the planned service efficiently using the best tools, techniques, and skilled professionals to ensure quality results.
            </p>
            {/* <div className="o-hidden">
              <a href="/dark/page-about2" className="rmore to-in mt-30">
                <span className="sub-title">Read More</span>
                <img
                  src="/dark/assets/imgs/arrow-right.png"
                  alt=""
                  className="icon-img-20 ml-5"
                />
              </a>
            </div> */}
          </div>
          <div className="col-lg-3 col-md-6 item">
            <div className="icon-img-60 mb-30">
              <img src="/dark/assets/imgs/serv-icons/devproc4.png" alt="" />
            </div>
            <h5 className="mb-15">Handover</h5>
            <p>
            Provide the finished solution along with guidance and support to ensure customer satisfaction and seamless maintenance.
            </p>
           
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;
